import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import getMe from '@/api/auth/getMe.endpoint';
import emailVerificationConstants from '@/v2/domains/Auth/constants/emailVerificationConstants';

export default function usePollEmailVerificationQuery() {
  return useQuery({
    queryKey: [QUERY_KEYS.ME],
    queryFn: () => getMe(),
    refetchInterval: emailVerificationConstants.pollIntervalMs,
    refetchOnWindowFocus: 'always',
    meta: {
      notification: {
        error: () => false,
      },
    },
  });
}
